
import * as angular from 'angular';

import { fn } from '@common/utils';
import UISafe = fn.UISafe;
import * as kutils from '../navkendo';
import { NavClientService, INavPageClientInfo, NavPageItem } from '../navdata/navdata';
import { INavGridImp } from '@common/navkendo/navgrid';
import { DialogService } from '@services/dialogservice';
import { SetUpToggleToolbar } from '../commoncontrols/commoncontrols';
import { NavPageAdminService } from '@common/navdata/navpageadminservice';
import { INavCustomization } from '@common/services/settingsservice';
import {
    IPageMetaData, IPageProperty, IViewConfiguration, IViewPropertyGroup,
    IViewPageDisplay, IViewProperty, IViewConfigurations, IPageObj
} from '../nav';

import { $PageItemExecuteUpate, Observable } from '@common/navdata';
import { CompatibilityService } from "@common/services/compatibilityservice";
import { ModalShowMultiSelect } from '@common/navkendo/multiselect';
import { Bind, constants, NavPageitemDockZones, SetRWFCustomColor } from '../navkendo';
import { INavPageItemEditOptions } from '@common/navkendo/navpageitems';

/** Controller to administer ViewConfigurations */
export class ViewAdminController extends Observable {
    static Template = require('./adminView.fragment.html');
    static events = {
        DisplayChange: "DisplayChange",
        DisplayChanged: "DisplayChanged",
        CurrentViewChanged: "CurrentViewChanged", // triggered by Object.defineProperty below
        CurrentViewConfigChanged: "CurrentViewConfigChanged", // triggered by Object.defineProperty below
        SetDirty: "SetDirty"
    };

    static $inject = ["$scope", "CompatibilityService", "DialogService", "NavClient", "NavUrl", "NavCustomization"];
    private navAdmin: NavPageAdminService;
    constructor($scope: ng.IScope, private $c: CompatibilityService, dlg: DialogService,
        private NavClient: NavClientService, private NavUrl: string, NavCustomization: INavCustomization) {
        super();
        this.navAdmin = new NavPageAdminService($c, <INavCustomization>{ ConfigName: NavCustomization.ConfigName, NavUrl: NavUrl });
        var me = $scope["View"] = this,
            viewController: ng.IFormController,
            tryApply = fn.tryProxy(() => { if (!$scope.$root.$$phase) { $scope.$apply(); } }, this);

        me.RefreshView = me.RefreshView.bind(me);
        me.RegisterDisplayChange = (cb: Function) => {
            var evName = ViewAdminController.events.DisplayChange;
            me.bind(evName, cb);
            return fn.once(() => me.unbind(evName, cb));
        };

        // DropDown Options
        this["OptPageDD"] = <kendo.ui.DropDownListOptions>{
            dataSource: me.CurrentViews,
            dataTextField: "Description",
            dataValueField: "PageName",
        };

        this["OptViewDD"] = <kendo.ui.DropDownListOptions>{
            dataSource: me.CurrentViewConfigs,
            dataTextField: "Title",
            dataValueField: "Name",
            select: SyncToModel
        };

        let events = ViewAdminController.events;
        var dockZones: NavPageitemDockZones;
        var waitForDocks = $scope.$on("kendoWidgetCreated", (s, widget: NavPageitemDockZones) => {
            if (!(widget instanceof NavPageitemDockZones))
                return;

            waitForDocks();
            waitForDocks = null;
            dockZones = widget;
            dockZones.bind(constants.NavDestroy , Bind(dockZones, () => propertiesChanged(false), 'DockMoved'));
            var bar = $("#mainRibbonBarContainer", widget.element.parents().last()),
                barContent = $(".tabs-content", bar);

            ($scope["actToggleHoverMenuBar"] = SetUpToggleToolbar()).Initialize(bar, barContent);

            $(widget.element).on("focusin.navAdminCiewCtrl click.navAdminCiewCtrl", "[navPropertyName], :data('kendoNavDock'), td[role='gridcell']", (e) => {
                var target = $(e.target),
                    dock = target.closest(":data('kendoNavDock')").data("kendoNavDock"),
                    grid = target.closest(":data('kendoNavGrid')").data("kendoNavGrid"),
                    gridProp = grid && grid.element.closest("[navPropertyName]").attr("navPropertyName"),
                    gridCell = grid && target.closest("td[role='gridcell']");

                // is target a grid cell
                if (gridCell && gridCell.length) {
                    var col = grid.LeafColumns()[grid.cellIndex(gridCell)];
                    if (col && col.field) {
                        var propPath = gridProp + "." + col.field;
                    }
                }

                // is target in grid: use active cell in grid
                if (!propPath && grid) {
                    var activeCell = $("#aria_active_cell", grid.element);
                    if (activeCell.length && (col = grid.LeafColumns()[grid.cellIndex(activeCell)]) && col.field) {
                        var propPath = gridProp + "." + col.field;
                    }
                }

                if (!propPath) {
                    let propelement = target.closest("[navPropertyName]");
                    // default : use Displayd property
                    if (!propPath) {
                        propPath = propelement.attr("navPropertyName");
                    }

                    // if one prop in Dock (grid!) use this one
                    if (!propPath && propelement.length == 0 && dock) {
                        // auto display single prop in dock
                        var inDockProps = $("[navPropertyName]", dock.element);
                        if (inDockProps.length == 1) {
                            propelement = inDockProps;
                        }
                    }
                }

                var dockId = (dock && dock.ID) || "",
                    propertyPath = propPath || "";
                if (dockId !== actions.DockId || propPath !== actions.PropertyPath) {
                    actions.Refresh(
                        {
                            DockId: (dock && dock.ID) || "",
                            PropertyPath: propPath || ""
                        });
                }
            });
            $scope.$on("$destroy", () => $([window, widget.element]).off(".navAdminCiewCtrl"));

            // TODO ...
            viewController = <ng.IFormController>$scope["adminViewController"];
            if (viewController) {
                $scope.$watch("adminViewController.$dirty", (newValue) => {
                    if (newValue) {
                        actions.Refresh({ IsDirty: true });
                    }
                });
            }
        });

        var propertiesChanged = (withRefresh : boolean = true) => {
            var s = actions.State();
            if(withRefresh) {
              me.RefreshView();
            }
            SyncToModel();
            s.IsDirty = true;
            actions.Refresh(s);
        },
            _Cycle = 0,
            actions = this["Actions"] = {
                /** Path of Property ( Name if not a sub- Property, or e.g. PurchLines.No for subProp */
                PropertyPath: "",
                /** ID of Current Dock/PropertyGroup */
                DockId: "",
                /** Marker State is Dirty (Changes from Server Representation took place */
                IsDirty: false,
                CurrentConfig: <IViewPropertyGroup>null,
                /** Currently Active ViewProperty */
                CurrentViewProp: <IViewProperty>null,
                /** Property for Currently Displayed Property */
                CurrentProperty: <IPageProperty>null,
                /** Page Client for Current Page */
                PageClient: <INavPageClientInfo>null,
                GetCurrentConfig: () => {
                    var dock = actions.DockId && dockZones.GetDockByID(actions.DockId);
                    return dock && <IViewPropertyGroup>dock.element.data("IViewPropertyGroup");
                },
                ResetToDefault: {
                    Enabled: true,
                    Execute: () => dlg.WhenConfirm("Sollen alle Darstellungen für die Konfiguration auf den Standard zurückgesetzt werden?")
                        .then(fn.proxy(me.save, me, true)),
                },
                DeleteProperty: {
                    Enabled: false,
                    Hidden: "Enabled",
                    Execute: () => {
                        var currConfig = actions.GetCurrentConfig(),
                            props = currConfig.Properties,
                            idx = props.indexOf(fn.FindFirst(props, "Name", actions.PropertyPath));
                        if (idx < 0)
                            throw new Error("Prop not found!");
                        return dlg.WhenConfirm("Eigenschaft '" + actions.PropertyPath + "' aus Inforegister '" + currConfig.Title + "' löschen?")
                            .then(() => {
                                props.splice(idx, 1);
                                propertiesChanged();
                            });
                    }
                },
                Save: {
                    Enabled: false,
                    Execute: () => {
                        return dlg.WhenConfirm("Änderungen an Konfiguration '" + this.CurrentConfig.Config.Description + "' speichern?").then(() => { SyncToModel(); return me.save().then(() => viewController && viewController.$setPristine()); });
                    }
                },
                RefreshView: {
                    Enabled: false,
                    Execute: () => { SyncToModel(); me._refresh(me.RefreshView()); }
                },
                NewView: {
                    Enabled: false,
                    Execute: () => dlg.ShowInput({ inputText: "Neue Ansicht", message: "Name der Ansicht", title: "RWF" })
                        .then(r => r.okPressed && CreateNewConfig(r.inputString, this.CurrentViewConfig)),
                },
                DeleteView: {
                    Enabled: false,
                    Execute: () => dlg.WhenConfirm("Ansicht löschen?").then(() => DeleteViewConfig(me.CurrentViewConfig)),
                },
                Select: {
                    Enabled: true,
                    Execute: () => {
                        return me.getCurrentClient().then((client) => {
                            let workOn: { // If single ArrayProp : use the detail Props
                                Get: () => IViewProperty[];
                                Set: (toSet: IViewProperty[]) => any,
                                ArrayProp?: string
                            };
                            var currConfig = actions.GetCurrentConfig();
                            workOn = { Get: () => currConfig.Properties, Set: (v) => currConfig.Properties = v };
                            let singleViewProp = currConfig && currConfig.Properties.length == 1 && currConfig.Properties[0],
                                singleProp = singleViewProp && client.MetaData.PropsByName[singleViewProp.Name];

                            if (singleViewProp.Details && singleProp.ArrayProperties) {
                                if (singleProp.ArrayProperties.LineDisplayMode == "ForceGroup") {
                                    workOn = { Get: () => singleViewProp.Details, Set: v => singleViewProp.Details = v, ArrayProp: singleProp.Name };
                                } else {
                                    // TODO : here is Grid, Cols have to be administered in Grid Col selection right now
                                }
                            }
                            return UISelectProps({
                                SelProps: workOn.Get(), ArrayProp: workOn.ArrayProp
                            }, selItems => {
                                workOn.Set(selItems);
                                propertiesChanged();
                            }, { title: "Felder im Bereich '" + (currConfig.Title || "").toUpperCase() + "'" });
                        });
                    }
                },
                SelectPropagated: {
                    Enabled: true,
                    Execute: () => {
                        var currConfig = actions.GetCurrentConfig(); // problem we started to persist those props in reverse order ...
                        var props = currConfig.PropagateProperties || (currConfig.PropagateProperties = []);

                        return UISelectProps({
                            SelProps: props.map(fn.identity).reverse(),
                            AvailProps: currConfig.Properties.map(item => item.Name)
                        }, selItems => {
                            currConfig.PropagateProperties = selItems.reverse();
                            propertiesChanged();
                        }, { title: "Propagierte Felder im Bereich '" + (currConfig.Title || "").toUpperCase() + "'" });
                    }
                },
                DeleteGroup: {
                    Enabled: false,
                    Execute: () => dlg.WhenConfirm("Inforegister '" + actions.GetCurrentConfig().Title + " löschen?")
                        .then(() => DeleteGroup(actions.CurrentConfig.ID))
                },
                AddGroup: {
                    Enabled: false,
                    Execute: () => dlg.ShowInput({ inputText: "Neues Inforegister", message: "Titel des Inforegisters", title: "RWF" })
                        .then(r => r.okPressed && NewGroup(r.inputString))
                },
                /** sync given Parmaters to Action Model */
                Refresh: (c?: { PageClient?: INavPageClientInfo; PropertyPath?: string, DockId?: string, IsDirty?: boolean }) => {
                    var prevState = actions.State();
                    angular.extend(actions, c);
                    _Cycle++;

                    // Re-set Property/Dock State if necessary
                    if (dockZones && !actions.PropertyPath && !actions.DockId) {
                        if (!actions.PropertyPath && prevState.PropertyPath) {
                            $("[navpropertyname='" + prevState.PropertyPath + "']", dockZones.element).focus().click();
                            if (_Cycle != prevState._Cycle)
                                return; // another refresh was triggered
                        }

                        if (!actions.DockId && prevState.DockId) {
                            $("#" + prevState.DockId + ":data('kendoNavDock')", dockZones.element).focus().click();
                            if (_Cycle != prevState._Cycle)
                                return; // another refresh was triggered
                        }
                    }

                    let propPath = actions.PropertyPath,
                        supProp = propPath && propPath.indexOf(".") >= 0,
                        viewConfig = me.CurrentViewConfig,
                        configs = me.CurrentConfig;

                    let config = actions.CurrentConfig = actions.GetCurrentConfig();
                    if (supProp) {
                        actions.CurrentViewProp = config && (() => {
                            var result = fn.FindFirst(fn.FlattenArray(config.Properties.map(item => (item.Details || []).map(d => { return { Item: d, Path: item.Name + "." + d.Name }; }))), item => item.Path == propPath);
                            return result && result.Item;
                        })();
                    } else {
                        actions.CurrentViewProp = config && fn.FindFirst(config.Properties, "Name", propPath);
                    }

                    actions.CurrentProperty = propPath && actions.PageClient && actions.PageClient.AllProperties[propPath];
                    actions.DeleteProperty.Enabled = !supProp && !!propPath && !!actions.DockId;
                    actions.Select.Enabled = actions.SelectPropagated.Enabled = !!actions.DockId;
                    actions.Save.Enabled = actions.IsDirty;
                    actions.ResetToDefault.Enabled = !!(configs && configs.IsCustomization !== false);
                    actions.RefreshView.Enabled = !!me.CurrentView;
                    actions.DeleteView.Enabled = !!(configs && viewConfig && viewConfig.Name != configs.DefaultView && me.CurrentViewConfigs.length > 1);
                    actions.NewView.Enabled = !!me.CurrentViewConfigs;
                    actions.AddGroup.Enabled = !!me.CurrentView;
                    actions.DeleteGroup.Enabled = !!config && me.CurrentView && me.CurrentView.Groups.length > 1;
                    tryApply();
                },
                State() {
                    return {
                        PropertyPath: actions.PropertyPath,
                        DockId: actions.DockId,
                        IsDirty: actions.IsDirty,
                        _Cycle: _Cycle
                    };
                },
                ResetBGColor : {
                  Execute : () => {
                    this.CustomBGColor = undefined;
                  }
                }
            };
        this.bind(events.CurrentViewChanged, () => { me.RefreshView(me.CurrentView); });
        this.bind(events.CurrentViewConfigChanged, () => {
            var config = me.CurrentViewConfig;
            var configs = me.CurrentConfig;
            config = config && config.Name && configs && configs.Views[config.Name];

            if (config) {
                var allCurrentViews = (config && <(IViewPageDisplay & kendo.data.ObservableObject)[]><any>fn.DictToArray(config.PerPage)).filter(item => !!item.Groups) || [];
                allCurrentViews.forEach(d => d["Description"] = (configs.Pages[d.PageName] || { Description: d.PageName }).Description);
            } else {
                allCurrentViews = [];
            }

            var currViews = this.CurrentViews;
            currViews.splice(0, currViews.length, ...allCurrentViews);
            me.CurrentViewConfig = config;

            if (me.CurrentView) {
                me.CurrentView = fn.FindFirst(allCurrentViews, v => v.PageName == this.CurrentView.PageName);
            }
            if (!me.CurrentView)
                me.CurrentView = allCurrentViews[0];

            actions.Refresh({ IsDirty: false });
            tryApply();
        });

        this.bind(events.DisplayChanged, () => {
            var view = me.CurrentView,
                pageName = view && view.PageName;
            actions.Refresh({
                PropertyPath: "", DockId: "",
                PageClient: me.loadedClients[pageName]
            });
        });

        this.load();
        // Reset all Events  on Scope Destroy
        $scope.$on("$destroy", fn.proxy(me.unbind, me, undefined));
        function SyncToModel() {
            if (!dockZones)
                return;

            var fromUI = dockZones.getCurrentView();
            var xxx = fromUI && me.CurrentConfig && me.CurrentConfig.Views[fromUI.ViewName];
            var toView = xxx && xxx.PerPage[fromUI.PageName];
            if (fromUI && toView && fromUI.PageName == toView.PageName) {
                toView.CustomBGColor = fromUI.CustomBGColor;
                if (!angular.equals(toView.Groups, fromUI.Groups)) {
                    toView.Groups = fromUI.Groups;
                    actions.Refresh({ IsDirty: true });
                    tryApply();
                }
            }
        }

        // Set Dirty when called
        this.bind(events.SetDirty, () => actions.Refresh({ IsDirty: true }));

        function UISelectProps(c: { SelProps: IViewProperty[], AvailProps?: string[], ArrayProp?: string }, apply: (selItems: IViewProperty[]) => void, config?: { pageName?: string, title?: string }) {
            return me.getCurrentClient(config && config.pageName).then(client => client.MetaData).then(rootMetadata => {
                var metadata = (c.ArrayProp && rootMetadata.PropsByName[c.ArrayProp].ArrayProperties) || rootMetadata;
                var availProps = metadata.Properties;
                if (c.AvailProps)
                    availProps = availProps.filter(p => c.AvailProps.indexOf(p.Name) >= 0);
                var props = availProps.map(p => {
                    return fn.FindFirst(c.SelProps, s => s.Name == p.Name) || <IViewProperty>{ Name: p.Name };
                }), propInfos = props.map(p => {
                    var prop = metadata.PropsByName[p.Name];
                    return { ViewProp: p, Property: prop, Title: prop.Title && prop.Title !== prop.Name ? prop.Title + "(" + prop.Name + ")" : prop.Name };
                }),
                    selPropInfos = fn.sort(propInfos.filter(p => c.SelProps.indexOf(p.ViewProp) >= 0), item => c.SelProps.indexOf(item.ViewProp));

                return ModalShowMultiSelect({
                    AllItems: propInfos,
                    ChosenItems: selPropInfos,
                    TitleChosen: "dargestellte Felder",
                    TitleUnchosen: "verfügbare Felder",
                    TemplateChosen: "<div style='padding: 2px 6px'  ng-class=\"model.Marked ? 'idms_CommandControl_Selected' : ''\" >{{item.Title}}</div>",
                    TemplateUnchosen: "<div style='padding: 2px 6px' ng-class=\"model.Marked ? 'idms_CommandControl_Selected' : ''\" >{{item.Title}}</div>",
                    title: (config && config.title) || "Felder",
                    events: {
                        apply: (items) => apply(items.map(item => item.ViewProp)),
                        revert: fn.noop
                    },
                    filter: (s, a) => {
                        return (s.Property.Name + s.Property.Title).toLowerCase().indexOf((a || "").toLowerCase()) >= 0;
                    }
                });
            });
        }

        function CreateNewConfig(name: string, _template: IViewConfiguration) {
            var clone = fn.clone(_template),
                id = fn.id();

            fn.DictToArray(clone.PerPage).forEach(c => c.ViewName = id);
            clone.Name = id;
            clone.Title = name;
            var toAdd = kutils.EnsureObservable(clone);
            me.CurrentConfig.Views[toAdd.Name] = toAdd;
            me.CurrentViewConfigs.push(toAdd);
            me.CurrentViewConfig = toAdd;
            actions.Refresh({ DockId: "", IsDirty: true });
        }

        function DeleteViewConfig(toDelete: IViewConfiguration) {
            var name = toDelete.Name,
                isCurrent = toDelete.Name == (me.CurrentViewConfig && me.CurrentViewConfig.Name),
                idx = me.CurrentViewConfigs.indexOf(<any>toDelete);
            if (idx < 0)
                return;

            delete me.CurrentConfig.Views[name];
            me.CurrentViewConfigs.remove(<any>toDelete);
            if (isCurrent)
                me.CurrentViewConfig = me.CurrentViewConfigs[Math.max(idx - 1, 0)];
            actions.Refresh({ DockId: "", IsDirty: true });
        }

        function DeleteGroup(id: string) {
            var view = me.CurrentView;
            var toDelete = fn.FindFirst(view.Groups, "ID", id);
            if (toDelete) {
                view.Groups.splice(view.Groups.indexOf(toDelete), 1);
                return me.RefreshView();
            }
        }

        function NewGroup(name: string) {
            var result: IViewPropertyGroup;
            me.CurrentView.Groups.push({
                ID: fn.id(),
                Title: name,
                Properties: [],
            });
            return me.RefreshView();
        }
    }

    public CurrentConfig: IViewConfigurations & kendo.data.ObservableObject;
    /** Currently Available View Configs */
    public CurrentViewConfigs = kutils.AsObservableArray<IViewConfiguration & kendo.data.ObservableObject>();
    /** Currently Displayed ViewConfig */
    public CurrentViewConfig: IViewConfiguration;
    /** Currently Available Views */
    public CurrentViews = kutils.AsObservableArray<IViewPageDisplay & kendo.data.ObservableObject>();
    /** Currently Displayed View (Config.View.Page) */
    public CurrentView: IViewPageDisplay;

    public get CustomBGColor() { return this.CurrentView?.CustomBGColor; }
    public set CustomBGColor(val) {
      var CurrentView = (this.CurrentView || {} as IViewPageDisplay);
      if (CurrentView && CurrentView.CustomBGColor !== val) {
        CurrentView.CustomBGColor = val;
        this.CurrentConfig.Pages[CurrentView.PageName].CustomBGColor = val;
        this.trigger(ViewAdminController.events.SetDirty);
        SetRWFCustomColor(val);
      }
    }

    public RegisterDisplayChange: (cb: Function) => Function;

    public RefreshView(currView?: IViewPageDisplay) {
        let events = ViewAdminController.events,
            setDirty = () => { this.trigger(events.SetDirty); };

        currView = this.CurrentView = currView || this.CurrentView;
        if (currView && currView.Groups.length == 0) {
            // Erzeuge Leere Gruppe falls keine vorhanden
            currView.Groups.push(<IViewPropertyGroup>{ ID: fn.id(), Properties: [], Title: "Neue Gruppe" });
            this.trigger(events.SetDirty);
        }
        var createTestItem = currView && currView.PageName ? this.getCurrentClient(currView.PageName).then((c) => CreateTestItem(this.NavClient, c)) : <PromiseLike<NavPageItem>>this.$c.when(undefined);

        currView.ChangeTracker = {}; // to force refresh
        return UISafe(this._refresh(createTestItem.then(testItem => {
            this.trigger(ViewAdminController.events.DisplayChange, <INavPageItemEditOptions>{
                View: currView,
                Item: testItem,
                Rendered: fn.proxy((e) => {
                    // Set Dirty on Column State Change on Grid(s)
                    $(":data('kendoNavGrid')", e).each((idx, elem) => {
                        var grid = $(elem).data("kendoNavGrid");
                        if (grid) {
                            INavGridImp.ColumnChangeEvents.forEach(name => {
                                grid.bind(name, setDirty);
                                this.one(ViewAdminController.events.DisplayChange, () => grid.unbind(name, setDirty));
                            });
                        }
                    });
                }, this),
                DesignMode: true,
                Register: this.RegisterDisplayChange
            });
            SetRWFCustomColor(currView?.CustomBGColor);
            this.trigger(ViewAdminController.events.DisplayChanged);
        })));
    }

    private getCurrentClient(pageName?: string) {
        pageName = pageName || this.CurrentView.PageName;
        return this.NavClient.GetPageClientInfo(pageName, this.NavUrl, false).then((client) => this.loadedClients[pageName] = client);
    }
    private loadedClients: { [pageName: string]: INavPageClientInfo } = <any>{};

    public IsInRefresh = false;
    private _refresh<T>(p: PromiseLike<T>) {
        this._refreshCounter++;
        this.IsInRefresh = true;
        const endRefresh = () => {
            this._refreshCounter--;
            this.IsInRefresh = --this._refreshCounter > 0;
        };
        p.then(endRefresh, endRefresh);
        return this.$c.when(p);
    }
    private _refreshCounter = 0;
    private setViewConfigurations(config: IViewConfigurations & kendo.data.ObservableObject) {
        var prev = this.CurrentConfig,
            prevViewConfig = this.CurrentViewConfig,
            prevname = prevViewConfig && prevViewConfig.Name;
        this.CurrentConfig = config;
        var allViews = fn.DictToArray((config && config.Views) || {}).filter(item => !!item.PerPage); // filter : ObserableObject extra Props!
        var configs = <IViewConfiguration[]><any>this.CurrentViewConfigs;
        configs.splice(0, configs.length, ...allViews);
        this.CurrentViewConfig = config && (prevname && config.Views[prevname]) || config.Views[config.DefaultView];
    }

    public load() {
        return this._refresh(UISafe(this.navAdmin.GetViewConfiguration().then(data => this.setViewConfigurations(kutils.EnsureObservable(data)))));
    }

    public save(asDelete?: boolean) {
        var toSave = asDelete ? {} : this.CurrentConfig.toJSON();
        this._refresh(this.navAdmin.SyncViewConfiguration( asDelete ? <any>{} : toSave));
        return this._refresh(this.navAdmin.SaveViewConfiguration(
            asDelete ? <any>{} : toSave // Empty Object as Parameter Deletes the Customization  
        ).then(reloaded => this.setViewConfigurations(kutils.EnsureObservable(reloaded))));
    }
}
// TODO .... just out of curiosity ...
(function _ViewAdminController() {
    var _defineProperty = fn.proxy(Object.defineProperty, Object);
    function BuildSavedependency(itemOrClass: any, propName: string, containerName: string, idName: string) {
        var _propname = "__$" + propName,
            trigger = "trigger" in itemOrClass,
            evName = propName + "Changed";

        _defineProperty(itemOrClass, propName, {
            set: function (value: any) {
                var theValue = (value && value[idName]) || undefined,
                    prev = this[_propname],
                    theContainer = this[containerName];

                value = (theValue && theContainer && fn.FindFirst(theContainer, idName, value[idName])) || undefined;
                if (prev !== value) {
                    this[_propname] = value;
                    if (trigger) {
                        this.trigger(evName, { Value: value });
                    }
                }
            },
            get: function () {
                return this[_propname];
            }
        });
    }
    // Setup "SAve Dependencies" (kendo Wraps/Unwraps displayed Objects, so we loose Object equality
    function _CurrentView() { var x: ViewAdminController; var t1 = x.CurrentViews; var t2 =  x.CurrentView.PageName = x.CurrentViews[0].PageName; }
    BuildSavedependency(ViewAdminController.prototype, "CurrentView", "CurrentViews", "PageName");
    function _x() { var x: ViewAdminController; var t1 = x.CurrentViewConfigs; var t2 = x.CurrentViewConfig.Name = x.CurrentViewConfigs[0].Name; }
    BuildSavedependency(ViewAdminController.prototype, "CurrentViewConfig", "CurrentViewConfigs", "Name");
})();

/** Create Test PageItem with no Connection to Backend and defaulted values */
function CreateTestItem(navClient: NavClientService, clientInfo: INavPageClientInfo) {
    function getTestData(m: IPageMetaData): IPageObj {
        return <any>fn.ToDictionaryEx(m.Properties, "Name", (p: IPageProperty) => {
            if (p.ArrayProperties) {
                return [getTestData(p.ArrayProperties)];
            } else if (p.EnumMappings && p.EnumMappings.length) {
                return p.EnumMappings[0].Value;
            } else {
                switch (p.Type) {
                    case "DateTime":
                        return new Date(2016, 2, 11);
                    case "Decimal":
                    case "Int32":
                        return 0;
                    case "Boolean":
                        return false;
                    default:
                        return "";
                }
            }
        });
    }

    var testData = getTestData(clientInfo.MetaData),
        testItem = navClient.CreateNew(clientInfo, testData);

    // prevent propagating Values to Server ...
    testItem.Model.bind($PageItemExecuteUpate, (e: kendo.ui.Event) => e.preventDefault());

    return testItem;
}
